/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

/**
 * Http Error.
 * This class property in StatusCode and ErrorCode[]
 */
export class HttpError extends Error {
  /**
   * constructor.
   * @param {Response} response
   * @param {number} statusCode
   * @param {string[] | undefined} errorCodes
   * @param {unknown | undefined} cause
   * @param {string | undefined} msg
   */
  constructor(
    public response: Response,
    public statusCode: number,
    public errorCodes?: string[],
    public cause?: unknown,
    msg?: string
  ) {
    super(msg);
    this.name = new.target.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
